import 'leaflet-selectareafeature';
import { LeafletMap } from './LeafletMap';

interface SelectedItem {
    id: string,
    color: string;
    fieldTitle: string;
}

export class LeafletSelectAreaFeature {
    geoMap: LeafletMap;
    selectfeature: any;

    constructor(geoMap: LeafletMap) {
        this.geoMap = geoMap;
    }

    // The selectAreaFeature plugin augments L.Map without type declarations,
    // so the map is accessed as `any` (as the old ItemsManager-based code did).
    private get map(): any {
        return this.geoMap.map;
    }

    enableAreaSelector(context: any) {
        let me = this;
        this.selectfeature = this.map.selectAreaFeature.enable();
        this.map.dragging.disable();
        this.selectfeature.options.color = '#663399';
        this.selectfeature.options.weight = 3;

        this.selectfeature.onDrawEnd = function () {
            console.log('Draw end');

            if (context.selectorCallback) {
                var areas = me.getSelectedAreas(context.kind);
                var args = { selectedItems: areas, kind: context.kind, layerId: context.baseLayerId }
                context.selectorCallback.callee.invokeMethodAsync(context.selectorCallback.function, args);
            }
            me.removeAllAreasDrawn();
        }
    }

    disableAreaSelector() {
        this.selectfeature.disable();
        this.selectfeature.onDrawEnd = null;
        this.map.dragging.enable();
    }

    removeAllAreasDrawn() {
        this.map.selectAreaFeature.removeAllArea();
    }

    getSelectedAreas(kind: string): Array<SelectedItem> {
        let ret = null;
        try {
            ret = this.map.selectAreaFeature.getFeaturesSelected(kind);
        }
        catch (ex) {

        }
        let arraySize = (ret === null ? 0 : ret.length);
        let items = Array<SelectedItem>(arraySize);

        for (let i = 0; i < arraySize; i++) {

            if (kind === 'polygon') {
                let p: SelectedItem = {
                    id: ret[i].options.id,
                    color: ret[i].options.style.fillColor,
                    fieldTitle: ret[i].options.fieldTitle
                }
                items[i] = p;
            }

            if (kind === 'marker') {
                let m: SelectedItem = {
                    id: ret[i].options.id,
                    color: ret[i].options.color,
                    fieldTitle: ret[i].options.fieldTitle
                }
                items[i] = m;
            }
        }
        return items;
    }
}
